export const getAggregatedBrands = (aggregatedBrands, brands, allBrands) =>
    (aggregatedBrands ? allBrands.filter((brand) => Object.keys(aggregatedBrands).includes(brand.key)) : allBrands).map(
        (brand) => {
            const usedBrand = brands.find((stateBrand) => stateBrand.key === brand.key);
            return usedBrand || { ...brand, checked: false };
        }
    );
